import React from "react";
import { NavLink } from "react-router-dom";
import { BiPieChart } from "react-icons/bi";
import { IoSettingsOutline } from "react-icons/io5";

const BusinessUserNav = ({ selectedBusiness }) => {
  const businessId = selectedBusiness?.id;

  // helper to render a nav item
  const Item = ({ to, end, icon: Icon, children }) => (
    <li>
      <NavLink
        to={to}
        end={end}
        className={({ isActive }) =>
          `nav-link ${isActive ? "active" : ""}`
        }
      >
        <Icon />
        <span>{children}</span>
      </NavLink>
    </li>
  );

  return (
    <div className="nav-panel">
      <div>
        <img
          src="/logo512.png"
          alt="Payweek Logo"
          className="dashboard-logo"
        />
      </div>

      <ul>
        {businessId && (
          <>
            <Item to={`/bus-dashboard/business/${businessId}/cash-recon`} icon={BiPieChart}>
              Cash-In
            </Item>
            <Item to={`/bus-dashboard/business/${businessId}/payroll-entry`} icon={BiPieChart}>
              Payroll
            </Item>
          </>
        )}

        <Item to="/bus-dashboard/business/user/profile" icon={IoSettingsOutline}>
          Settings
        </Item>
      </ul>
    </div>
  );
};

export default BusinessUserNav;




// import React from "react";
// import { Link } from "react-router-dom";
// import { BiPieChart } from "react-icons/bi";
// //import { LuFilePenLine } from "react-icons/lu";
// //import { PiInvoice } from "react-icons/pi";
// //import { FiUsers } from "react-icons/fi";
// //import { LiaMoneyCheckAltSolid } from "react-icons/lia";
// import { IoSettingsOutline } from "react-icons/io5";

// const BusinessUserNav = ({ selectedBusiness }) => {
//   const businessId = selectedBusiness?.id;

//   return (
//     <div className="nav-panel">
//       <div>
//         <img
//           src="/logo512.png"
//           alt="Payweek Logo"
//           className="dashboard-logo"
//         />
//       </div>

//       <ul>
//         {businessId && (
//           <>
//             {/* <li style={{ fontSize: "14px", marginTop: "30px" }}>
//               <Link to={`/bu/business/${businessId}`}>
//                 <IoBusinessOutline /> Business Page
//               </Link>
//             </li>
//             <li style={{ fontSize: "14px" }}>
//               <Link to={`/bu/business/${businessId}/employees`}>
//                 <FiUsers /> Employees
//               </Link>
//             </li>
//             <li style={{ fontSize: "14px" }}>
//               <Link to={`/bu/business/${businessId}/viewpayroll`}>
//                 <LiaMoneyCheckAltSolid /> Payroll
//               </Link>
//             </li>
//             <li style={{ fontSize: "14px" }}>
//               <Link to={`/bu/business/${businessId}/check-write`}>
//                 <LuFilePenLine /> Check Writer
//               </Link>
//             </li>
//             <li style={{ fontSize: "14px" }}>
//               <Link to={`/bu/business/${businessId}/invoiceref`}>
//                 <PiInvoice /> Invoice
//               </Link>
//             </li> */}
//             {/* Accounting -> Cash-In Reconciliation for BU */}
//             <li style={{ fontSize: "14px" }}>
//               <Link to={`/bus-dashboard/business/${businessId}/cash-recon`}>
//                 <BiPieChart /> Cash-In
//               </Link>
//               <Link to={`/bus-dashboard/business/${businessId}/payroll-entry`}>
//                 <BiPieChart /> Payroll
//               </Link>
//             </li>
//           </>
//         )}

//         <>
          
//            <li style={{ fontSize: "13px" }}>
//             <Link to="/bus-dashboard/business/user/profile">
//               <IoSettingsOutline /> Settings
//               <span className="settings-text"></span>
//             </Link>
//           </li>
//         </>
//       </ul>
//     </div>
//   );
// };

// export default BusinessUserNav;





// import React from "react";
// import { Link } from "react-router-dom";
// import { BiPieChart } from "react-icons/bi";
// import { LuFilePenLine } from "react-icons/lu";
// import { PiInvoice } from "react-icons/pi";
// import { FiUsers } from "react-icons/fi";
// import { LiaMoneyCheckAltSolid } from "react-icons/lia";
// import { IoBusinessOutline, IoSettingsOutline } from "react-icons/io5";
// //import "./BusinessDashboard.css";

// const BusinessUserNav = ({ selectedBusiness }) => {
//   const businessId = selectedBusiness?.id;

//   return (
//     <div className="bu-nav-panel">
//       <div className="bu-nav-logo">
//         <img src="/logo512.png" alt="Payweek Logo" className="dashboard-logo" />
//       </div>
//       <ul className="bu-nav-list">
//         {businessId && (
//           <>
//             <li><Link to={`/bu/business/${businessId}`}><IoBusinessOutline/> Business Page</Link></li>
//             <li><Link to={`/bu/business/${businessId}/employees`}><FiUsers/> Employees</Link></li>
//             <li><Link to={`/bu/business/${businessId}/viewpayroll`}><LiaMoneyCheckAltSolid/> Payroll</Link></li>
//             <li><Link to={`/bu/business/${businessId}/check-write`}><LuFilePenLine/> Check Writer</Link></li>
//             <li><Link to={`/bu/business/${businessId}/invoice`}><PiInvoice/> Invoice</Link></li>
//             <li><Link to={`/bu/business/${businessId}/accounting`}><BiPieChart/> Accounting</Link></li>
//           </>
//         )}
//         <li className="bu-nav-settings">
//           <Link to="/bu/profile">
//             <IoSettingsOutline/> Settings
//           </Link>
//         </li>
//       </ul>
//     </div>
//   );
// };

// export default BusinessUserNav;
